import { render, staticRenderFns } from "./company-agent.vue?vue&type=template&id=642882b3&scoped=true&"
import script from "./company-agent.vue?vue&type=script&lang=js&"
export * from "./company-agent.vue?vue&type=script&lang=js&"
import style0 from "./company-agent.vue?vue&type=style&index=0&id=642882b3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642882b3",
  null
  
)

export default component.exports